import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../../general/base/base.component';

@Component({
  selector: 'qm-notification-types',
  templateUrl: './notification-types.component.html',
  styleUrls: ['./notification-types.component.scss']
})
export class NotificationTypesComponent extends BaseComponent implements OnInit {

  public show: boolean = false;


  constructor(private modalService: NgbModal) {
    super();
    this.name = 'NotificationTypeComponent';
  }

  ngOnInit() {
  }

  public open(content: HTMLElement) {
    this.modalService.open(content, {size: 'lg'});
  }

  public close() {
    this.modalService.dismissAll();
  }

}
